<template>
  <div class="app-tab" v-bind="$attrs" :id="id" v-on="$listeners">
    <slot />
  </div>
</template>

<script>
  import uuid from 'core/utils/uuid'

  export default {
    name: 'AppTab',
    props: {
      id: {
        type: String,
        default: () => 'app-tab-' + uuid()
      },
      disabled: Boolean,
      label: [String, Number],
      templateData: {
        type: Object,
        default: () => ({})
      }
    },
    inject: ['AppTabs'],
    watch: {
      $props: {
        deep: true,
        handler () {
          this.setTabData()
        }
      },
      $attrs: {
        deep: true,
        handler () {
          this.setTabData()
        }
      }
    },
    methods: {
      setTabContent () {
        this.$set(this.AppTabs.items[this.id], 'hasContent', !!this.$slots.default)
      },
      setTabData () {
        this.$set(this.AppTabs.items, this.id, {
          hasContent: !!this.$slots.default,
          label: this.label,
          disabled: this.disabled,
          data: this.templateData,
          props: this.getPropValues(),
          events: this.$listeners
        })
      },
      getPropValues () {
        const propNames = Object.keys(this.$options.props)
        const ignoredProps = ['id', 'label', 'disabled', 'templateData']
        let values = {}

        propNames.forEach(prop => {
          if (!ignoredProps.includes(prop)) {
            if (this[prop]) {
              values[prop] = this[prop]
            } else if (this.$attrs.hasOwnProperty(prop)) {
              if (prop) {
                values[prop] = this.$attrs[prop]
              } else {
                values[prop] = true
              }
            }
          }
        })

        return values
      }
    },
    mounted () {
      this.setTabData()
    },
    beforeDestroy () {
      this.$delete(this.AppTabs.items, this.id)
    }
  }
</script>

<style lang="scss" scoped>
  .app-tab {
    width: 100%;
    flex: 1 0 100%;
  }
</style>
